import React from "react";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    padding: "3%"
  },
  container: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "space-evenly",
    alignContent: "stretch",
    alignItems: "stretch"
  },
  item: {
    flexGrow: 1,
    flexBasis: "49%"
  }
}));

const TipoCobertura = ({ value, onChange }) => {
  const handleChange = event => {
    onChange(event);
  };

  const classes = useStyles();

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend" />
      <RadioGroup
        aria-label="position"
        name="position"
        value={value}
        onChange={handleChange}
        row
      >
        <div className={classes.container}>
          <div className={classes.item}>
            <FormControlLabel
              value="RC"
              control={<Radio color="default" />}
              label="Responsabilidad Civil"
            />
          </div>
          <div className={classes.item}>
            <FormControlLabel
              value="TCBase"
              control={<Radio color="secondary" />}
              label="Terceros Completo"
            />
          </div>
          <div className={classes.item}>
            <FormControlLabel
              value="TCPremium"
              control={<Radio color="secondary" />}
              label="Terceros Premium"
            />
          </div>
          <div className={classes.item}>
            <FormControlLabel
              value="TR"
              control={<Radio color="primary" />}
              label="Todo Riesgo"
            />
          </div>
        </div>
      </RadioGroup>
    </FormControl>
  );
};

export default TipoCobertura;
